module.exports = __webpack_public_path__ + "img/01841_03.4addd04f.png";